import React from 'react';
import { Button, Snackbar, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function CookieSnackbar({ open, onAccept }) {
    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            message={
                <span>
                    Wir verwenden Cookies, um die Nutzung unserer Website zu analysieren und deine Erfahrung zu verbessern.{' '}
                    <MuiLink component={RouterLink} to="/privacy" color="inherit" underline="always">
                        Datenschutz
                    </MuiLink>{' '}
                    &middot{' '}
                    <MuiLink component={RouterLink} to="/imprint" color="inherit" underline="always">
                        Impressum
                    </MuiLink>
                </span>
            }
            action={
                <Button
                    variant="contained"
                    size="small"
                    onClick={onAccept}
                    sx={{ bgcolor: 'orange', '&:hover': { bgcolor: '#cc7a00' } }}
                >
                    Akzeptieren
                </Button>
            }
        />
    );
}
